import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Pagination, PaginationItem, PaginationLink} from "reactstrap";
import {useSearchParams} from "react-router-dom";

const MAX_PAGE_ITEMS = 4
const TablePagination = ({
                             pagesCount,
                             currentPage,
                             handlePageClick,
                             useParams,
                             isDisabled,
                             total,
                             perPage,
                             children,
    contentClassName = ''
}) => {

    const [searchParams, setSearchParams] = useSearchParams()

    const initPageItems = (count, current) => {
        let items = [current];
        let unshiftFirst = current <= MAX_PAGE_ITEMS;
        if (count && count > 1) {
            const addNext = () => {
                let nextPageItem = current + 1;
                while (items.length < MAX_PAGE_ITEMS && nextPageItem < count) {
                    items.push(nextPageItem);

                    nextPageItem++
                }
            }

            const addPrev = () => {
                let prevPageItem = current - 1;
                while (prevPageItem > 0 && items.length < MAX_PAGE_ITEMS) {
                    items.unshift(prevPageItem);

                    prevPageItem--
                }
            }

            if (unshiftFirst) {
                addPrev();
                if (items.length < MAX_PAGE_ITEMS) {
                    addNext()
                }
            }else {
                addNext();
                if (items.length < MAX_PAGE_ITEMS) {
                    addPrev()
                }
            }


        }
        return items
    }


    const pageItems = useMemo(() => {
        return initPageItems(pagesCount, currentPage);
    }, [currentPage, searchParams.toString(),pagesCount, perPage, isDisabled]);

    const onPageClick = async(page) => {
        if(useParams) {
            let params = new URLSearchParams(searchParams);
            params.set('page', String(page));
            return setSearchParams(params, {replace: true});
        }
        if(handlePageClick) return handlePageClick(page);
    }
    const onPrevClick = () => {
        return onPageClick(currentPage - 1)
    }

    const onNextClick = () => {
        return onPageClick(currentPage + 1)
    }
    if (total === 0) {
        return children || null;
    }
    return (
        <div className={"table-pagination"}>
            <div className={"table-pagination-info " + contentClassName}>
                {TB.isDefined(total) && TB.isDefined(perPage) && (
                    <p>
                        {pagesCount > 1 ?
                            `Showing ${(currentPage * perPage) - perPage + 1} to ${Math.min(total, currentPage * perPage)} out of ${TB.pluralize("result", total, true)}`
                            : (
                            `Showing ${TB.pluralize("result", total, true)}`
                        )}
                    </p>
                )}

                {children && (
                    <div className="pagination-children">
                        {children}
                    </div>
                )}
            </div>

            {pagesCount > 1 && (
                <Pagination>
                    <PaginationItem disabled={isDisabled || ((currentPage -1) <= 0)}>
                        <PaginationLink onClick={() => onPrevClick()} href="">
                            <i className="fa fa-caret-left"/>
                        </PaginationLink>
                    </PaginationItem>

                    {pageItems?.length > 0 && (TB.first(pageItems) - 1) > 0 && (
                        <PaginationItem disabled={isDisabled}>
                            <PaginationLink onClick={() => onPageClick(TB.first(pageItems) - 1)} href="">
                                ...
                            </PaginationLink>
                        </PaginationItem>
                    )}
                    {pageItems.map((page, i) => (
                        <PaginationItem disabled={isDisabled} active={page === currentPage} key={page}>
                            <PaginationLink onClick={e => onPageClick(page)} href="">
                                {page}
                            </PaginationLink>
                        </PaginationItem>
                    ))}
                    {pageItems?.length > 0 && (TB.last(pageItems) + 1) <= (pagesCount -1) && (
                        <PaginationItem disabled={isDisabled || currentPage >= pagesCount}>
                            <PaginationLink onClick={() => onPageClick(TB.last(pageItems) + 1)} href="">
                                ...
                            </PaginationLink>
                        </PaginationItem>
                    )}
                    {pageItems?.length > 0 && (TB.last(pageItems) + 1) <= pagesCount && (
                        <PaginationItem disabled={isDisabled || currentPage > pagesCount} active={pagesCount === currentPage}>
                            <PaginationLink onClick={() => onPageClick(pagesCount)} href="">
                                {pagesCount}
                            </PaginationLink>
                        </PaginationItem>
                    )}
                    <PaginationItem disabled={isDisabled || currentPage >= pagesCount}>
                        <PaginationLink onClick={() => onNextClick()} href="">
                            <i className="fa fa-caret-right"/>
                        </PaginationLink>
                    </PaginationItem>
                </Pagination>
            )}
        </div>
    )
}

TablePagination.propTypes = {
    pagesCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    isDisabled: PropTypes.bool
};

export default TablePagination